export const project_list = [
  {
    project_name: "TBREAKOUT",
    project_description:
      "A terminal-based Breakout game written in Go, designed for fast gameplay directly inside your shell.",
    stack: ["Go", "Terminal", "Homebrew", "AUR (yay)"],
    highlight:
      "Installable on macOS via brew and on Linux via yay for quick CLI setup.",
    project_link_1: "https://github.com/Geralt-Of-Rivia-Witcher/tbreakout/",
  },
  {
    project_name: "PULL MAGE",
    project_description:
      "Pull Mage is your ultimate companion for managing PRs on GitHub. It can review your PRs, explain the changes, and answer your questions.",
    stack: ["Nest.js", "GitHub Apps", "LLMs", "Automation"],
    highlight:
      "Automates PR review workflows and reduces manual context-switching.",
    project_link_1: "https://github.com/Geralt-Of-Rivia-Witcher/Pull-Mage/",
    project_link_2: "https://github.com/apps/pull-mage",
  },
  {
    project_name: "DARKHOLD",
    project_description:
      "Unbreakable cloud storage with unique Hybrid Cryptography. Protect your files with top-notch encryption for unparalleled security.",
    stack: ["React", "Node.js", "S3", "Cloud"],
    highlight:
      "Built around secure file handling and layered encryption flows.",
    project_link_1: "https://github.com/Geralt-Of-Rivia-Witcher/Darkhold/",
    project_link_2: "https://darkhold.siddhantkumarsingh.me/",
  },
  {
    project_name: "GAMOPEDIA",
    project_description:
      "Your ultimate source for comprehensive video game information. From classic titles to the latest releases, it provides detailed video-game information.",
    stack: ["React", "Public APIs", "Caching", "UI Engineering"],
    highlight: "Aggregates and presents large game datasets in a usable way.",
    project_link_1:
      "https://github.com/Geralt-Of-Rivia-Witcher/Gamopedia_Frontend/",
    project_link_2: "https://gamopedia.siddhantkumarsingh.me/",
  },
];
